import React, { useEffect, useState } from "react";
import {
  postGenerateQrCode,
  postRemoveQrCode,
  postVerifyQrCode,
} from "../../../../services/CommonService";
import { toast } from "react-toastify";
import Utils from "../../../../utils";

function Security() {
  const [loading, setLoading] = useState(false);
  const [qrUrl, setQrUrl] = useState("");
  const [accountName, setAccountName] = useState("");
  const [yourKey, setYourKey] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [code, setCode] = useState("");
  let errorsObj = {
    code: "",
  };
  const [errors, setErrors] = useState(errorsObj);

  useEffect(() => {
    postGenerateQrCode({})
      .then((response) => {
        setIsVerified(response.data.is_verified);
        setQrUrl(response.data.url);
        setAccountName(response.data.data.qr_account_name);
        setYourKey(response.data.data.qr_key);
      })
      .catch((err) => { });
  }, []);

  const handleVerifyCode = (e) => {
    e.preventDefault();

    let error = false;
    let errorObj = { ...errorsObj };
    if (!code) {
      error = true;
      errorObj.code = "Please enter the code";
    }

    setErrors(errorObj);

    if (error) return;

    setLoading(true);
    let obj = {
      code: code,
    };
    postVerifyQrCode(obj)
      .then((response) => {
        setIsVerified(true);
        setLoading(false);
        toast.success(response.data.message);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleRemoveCode = (e) => {
    e.preventDefault();

    setLoading(true);
    postRemoveQrCode({})
      .then((response) => {
        setLoading(false);
        setIsVerified(false);
        setCode("");
        toast.success(response.data.message);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  return (
    <>
      {loading && (
        <div className="page-loading">
          <img src="/images/loader.gif" alt="loader" />
        </div>
      )}


      <div
        className="tab-pane setting-pane"
        id="nav-Security"
        role="tabpanel"
        aria-labelledby="nav-security-tab"
      >
        <div className="setting-single">
          <div className="setting-card">
            <div className="setting-card-header">
              <div>
                <h1 className="setting-title mt-2 mb-1">
                  Two‑Factor Authentication
                </h1>
                <p className="setting-subtitle mb-2">
                  Follow these quick steps to set up or update 2FA on your account.
                </p>
                <p className="setting-meta-text">
                  Status:{" "}
                  <span
                    className={
                      isVerified
                        ? "setting-status setting-status-on"
                        : "setting-status setting-status-off"
                    }
                  >
                    {isVerified ? "Enabled" : "Disabled"}
                  </span>{" "}
                  
                </p>
              </div>
            </div>

            {isVerified && (
              <div className="setting-alert setting-alert-success">
                <span className="setting-alert-icon">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </span>
                <div>
                  <div className="setting-alert-title">
                    Authentication enabled
                  </div>
                  <p className="setting-alert-text">
                    Your account is protected with two‑factor authentication.
                  </p>
                </div>
              </div>
            )}

            {/* Steps same as pehle right side wale */}
            <div className="setting-steps">
              {/* Step 1 */}
              <div className="setting-step">
                <div className="setting-step-indicator">
                  <span className="setting-step-number">1</span>
                </div>
                <div className="setting-step-body">
                  <h3 className="setting-step-title">
                    Download Google Authenticator
                  </h3>
                  <p className="setting-step-desc">
                    Install Google Authenticator from the Apple App Store or
                    Google Play Store on your mobile device.
                  </p>
                </div>
              </div>

              {/* Step 2 */}
              <div className="setting-step">
                <div className="setting-step-indicator">
                  <span className="setting-step-number">2</span>
                </div>
                <div className="setting-step-body">
                  <h3 className="setting-step-title">
                    Scan the QR code
                  </h3>
                  <p className="setting-step-desc">
                    Open the app, choose “Scan QR code”, and point your camera
                    at the code below.
                  </p>

                  <div className="setting-qr-row">
                    {qrUrl && (
                      <div className="setting-qr-wrapper">
                        <img
                          src={qrUrl}
                          alt="Authenticator QR"
                          className="setting-qr-img"
                        />
                      </div>
                    )}

                    {accountName && yourKey && (
                      <div className="setting-manual">
                        <div className="setting-manual-label">
                          Can’t scan the code?
                        </div>
                        <p className="setting-manual-text">
                          Add a new account in your authenticator app and manually
                          enter these details.
                        </p>
                        <div className="setting-manual-field">
                          <span className="setting-manual-field-label">
                            Account name
                          </span>
                          <span className="setting-manual-field-value">
                            {accountName}
                          </span>
                        </div>
                        <div className="setting-manual-field">
                          <span className="setting-manual-field-label">
                            Your key
                          </span>
                          <span className="setting-manual-field-value">
                            {yourKey}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* Step 3 */}
              <div className="setting-step">
                <div className="setting-step-indicator">
                  <span className="setting-step-number">3</span>
                </div>
                <div className="setting-step-body">
                  <h3 className="setting-step-title">
                    Verify your code
                  </h3>
                  <p className="setting-step-desc">
                    Enter the 6‑digit code currently shown in your authenticator
                    app to complete the setup.
                  </p>

                  {!isVerified && (
                    <div className="setting-code-row">
                      <div className="input-group">
                        <input
                          type="text"
                          className={`code-input ${errors.code ? "error" : ""}`}
                          value={code}
                          onChange={(e) => setCode(e.target.value)}
                          placeholder="000000"
                          maxLength="6"
                        />
                        {errors.code && (
                          <div className="error-message">{errors.code}</div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Footer buttons */}
            <div className="ssetting-form-actions">
              {!isVerified && (
                <button
                  type="button"
                  onClick={handleVerifyCode}
                  className="setting-btn-primary"
                >
                  Enable authentication
                </button>
              )}
              {isVerified && (
                <button
                  type="button"
                  onClick={handleRemoveCode}
                  className="setting-btn-primary"
                >
                  Disable authentication
                </button>
              )}

            </div>
          </div>
        </div>
      </div>

    </>
  );
}

export default Security;
